export enum THEME_MODES {
  DARK = "dark",
  LIGHT = "light",
}

export const STORAGE_THEME_NAME = "theme";
